//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        item: Object
    },
    computed: {
        liker() {
            return this.item.liker
        },
        is_consultant() {
            return this.item.liker.is_consultant
        }
    },
    methods: {
        goConsultantCard() {
            if(this.is_consultant){
                wx.navigateTo({
                    url: `/pages/consultants/card/main?id=${this.liker.consultant_id}`
                })
            }
        }
    }
}
